import React from "react";

const TagCloud = ({ tags = [] }) => {
  if (!tags.length) return <p className="text-muted mb-0">No tags.</p>;
  return (
    <div className="d-flex flex-wrap gap-2">
      {tags.map((t) => (
        <a
          key={t.id || t.slug}
          href={`/tag/${t.slug ?? t.id}`}
          className="badge bg-light text-dark border"
        >
          #{t.name}
        </a>
      ))}
    </div>
  );
};

export default TagCloud;
